
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Search from 'vux/src/components/search/index.vue'

import mobileTree from '@/components/mobile-tree-vue'
import {listDevice} from '@/api/device';
import {getInfo} from '@/api/login';
import InfiniteLoading from 'vue-infinite-loading';
import store from '@/store'
import logoImg from '@/assets/logo2.png'
import {treeselect} from "@/api/system/dept";

export default {
name: 'device',
components: {
Grid,
XButton,
GridItem,
CellBox,
Flexbox,
Card,
FlexboxItem,
Toast,
Icon,
Search,
mobileTree,
InfiniteLoading
},
data() {
return {
deviceList: [],
pageSize: 10,
pageIndex: 0,
userInfo: {},
logo: '',
searchValue: '',
deptOptions: [],
tree: [
{
label: '集团总部',
total: 20,
children: [
{
label: '集团党委',
total: 5,
children: [
{
label: '张三',
children: [],
},
{
label: '李四',
children: [],
},
{
label: '王五',
children: [],
},
],
},
],
},
],
}
},
created() {
this.getUser();
this.getTreeselect();
},
methods: {
reLogin() {
this.$cookies.set('reLogin',1);
this.$router.push('/');
},
async getUser() {
getInfo().then(res => {
this.userInfo = res.user
let logo = this.userInfo.dept ? (this.userInfo.dept.logoH5 ? process.env.VUE_APP_BASE_API + this.userInfo.dept.logoH5 : '') : '';
store.commit('SET_LOGO', logo)
store.commit('SET_ROLES', res.roles)
store.commit('SET_PERMISSIONS', res.permissions)
if (logo) {
this.logo = logo;
} else {
this.logo = logoImg;
}

}).catch(error => {
this.$vux.toast.show({
type: 'warn',
text: error
})
})
},
/** 查询部门下拉树结构 */
getTreeselect() {
treeselect().then(response => {
this.deptOptions = response.data;
});
},
onSubmit () {
this.$refs.search.setBlur()
this.pageIndex = 0;
this.deviceList = []
this.onInfinite()
},
onCancel () {
this.$refs.search.setBlur()
this.pageIndex = 0;
this.deviceList = []
this.searchValue = ''
this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
},
async onInfinite() {
const params = {
pageNum: ++this.pageIndex,
pageSize: this.pageSize,
name: this.searchValue
};
listDevice(params).then(response => {
if (response.rows.length) {
this.deviceList = this.deviceList.concat(response.rows);
this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
if (this.deviceList.length >= response.total) {
this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
}
} else {
this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
}
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/device.vue